import { Permissions } from "@cnx/common";
import { FEATURE_CHAT } from "common/constants";
import { useFeatureSupport } from "hooks/useFeatureSupport";
import { useAuthStore } from "stores/authStore";

export const useChatAvailability = () => {
  const { isFeatureEnabled } = useFeatureSupport();
  const useRights = new Set(useAuthStore(store => store.useRights));

  return (
    (useRights.has(Permissions.RIGHTS_CHAT_USER) ||
      useRights.has(Permissions.RIGHTS_CHAT_ADMIN)) &&
    isFeatureEnabled(FEATURE_CHAT)
  );
};
